import React from 'react';
import clamp from 'lodash/clamp';

const Highlights = ({ items = [], className = '' }) => {
    return (
        <div className={`highlights ${className}`.trim()}>
            {items.map((item) => (
                <div
                    key={item.key}
                    className={`highlights__card ${item.cardClass || ''}`}
                    onClick={() => item.onClick && item.onClick(item)}
                    {...(item.onClick && {
                        role: 'button',
                        tabIndex: 0,
                        onKeyDown: (e) => (e.key === 'Enter' || e.key === ' ') && item.onClick(item),
                    })}
                >
                    <p className="highlights__label">{item.label}</p>
                    <h3 className={`highlights__value ${item.valueClass || ''}`}>{item.displayValue}</h3>
                    <p className="highlights__meta">{item.meta || ' '}</p>
                    {item.progress != null && (
                        <div className="highlights__progress-track">
                            <div className="highlights__progress-fill" style={{ width: `${clamp(item.progress, 0, 100)}%` }} />
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

export default Highlights;
